<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>

            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                     :size="GCONFIG.styleElFormSize">
                <el-form-item label="活动名称">
                    <el-input v-model="formInline.activeName" placeholder="活动名称"></el-input>
                </el-form-item>
                <el-form-item label="活动类型">
                    <el-select v-model="formInline.activeType" clearable filterable placeholder="请选择活动类型">
                        <el-option
                                v-for="item in activeTypeList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动状态">
                    <el-select v-model="formInline.status" clearable filterable placeholder="活动状态">
                        <el-option
                                v-for="item in activeStatusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="活动号">-->
                <!--<el-input v-model="formInline.activeNo" placeholder="活动号"></el-input>-->
                <!--</el-form-item>-->
                <el-form-item label="绑定码">
                    <el-input v-model="formInline.bindCode" placeholder="请输入bindCode查询"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getAllActivelist">查询</el-button>
                    <el-button type="success" size="mini" @click="addActive()">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="activeList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="40"></el-table-column>
                <el-table-column label="活动信息" width="270">
                    <template slot-scope="scope">
                        <h4><p>活动名称:{{scope.row.activeName}}</p></h4>
                        <p>活动号:{{scope.row.activeNo}}</p>
                        <p>bindCode:{{scope.row.bindCode}}</p>
                    </template>
                </el-table-column>
                <!--<el-table-column label="活动号" width="180" prop="activeNo"></el-table-column>-->
                <!--<el-table-column prop="bindCode" label="bindCode" width="150"></el-table-column>-->
                <!--<el-table-column prop="activeName" label="活动名称" width="170"></el-table-column>-->
                <el-table-column prop="activeType" label="活动类型" width="130">
                    <template slot-scope="scope">
                        <span>{{ getActiveTypeName(scope.row.activeType) }}</span>
                    </template>
                </el-table-column>

                <el-table-column label="有效期" width="250">
                    <template slot-scope="scope">
                        <p>开始时间:{{formatDate(scope.row.beginTime)}}</p>
                        <p>结束时间:{{formatDate(scope.row.endTime)}}</p>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="endTime" label="结束时间" width="150">-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{formatDate(scope.row.endTime)}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column prop="promotionName" label="关联促销" width="150">
                    <template slot-scope="scope">
                        <el-button type="success" size="mini" @click="handlePromotion(scope.row)" class="header-btn">
                            {{scope.row.promotionName}}

                        </el-button>
                        <el-tooltip class="item" effect="dark" content="点击跳转页面查看促销详情" placement="top-start">
                            <p class="el-icon-question"></p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="countdown" label="到计时/状态" sortable width="120">
                    <template slot-scope="scope">
                        <p>到计时:{{scope.row.countdown == 0 ? '不显示' : '显示'}}</p>
                        <p>状态:{{scope.row.status == 1 ? '已上线' : '已下线'}}</p>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="status" label="状态" width="80" sortable>-->
                <!--<template slot-scope="scope">-->
                <!--<span>{{scope.row.status == 1 ? '已上线' : '已下线'}}</span>-->
                <!--</template>-->
                <!--</el-table-column>-->

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button type="primary" size="mini" @click="editeActive(scope.row)">编辑</el-button>
                            <el-button v-if="scope.row.status!==1" size="mini" type="warning" effect="plain"
                                       @click="checkActive(scope.row)">上线


                            </el-button>
                            <el-button v-if="scope.row.status===1" size="mini" type="success"
                                       @click="checkActive(scope.row)" effect="plain">下线


                            </el-button>
                            <!--                    <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>-->
                            <!--                    <el-button type="warning" size="mini" v-show="scope.row.activeType == 0" @click="handlePicProperty(scope.row)">图片连接</el-button>-->
                            <!--                    <el-button type="primary" size="mini" @click="handleQrcode(scope.row)">二维码</el-button>-->
                            <!--                    <el-button type="success" size="mini" @click="handleCoupon(scope.row)">优惠券</el-button>-->
                            <!--                    <el-button type="primary" size="mini" @click="handleRule(scope.row)" v-show="getFitType(scope.row.activeType)">规则</el-button>-->
                            <!--                    <el-button type="primary" size="mini" @click="handleGroupon(scope.row)" v-show="getGrouponShow(scope.row.activeType)">团购配置</el-button>-->
                            <!--                    <el-button type="primary" size="mini" @click="handlePage(scope.row)" v-show="getPageShow(scope.row.activeType)">页面配置</el-button>-->
                            <!--                    <el-button type="primary" size="mini" v-if="scope.row.activeType == 9" @click="handleCheckIn(scope.row.activeNo)">打卡次数和提醒</el-button>-->
                            <el-button type="info" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                            <el-button type="danger" size="mini" @click="handlecopyActive(scope.row)">复制</el-button>
                            <el-button type="primary" v-show="scope.row.activeType==43" size="mini"
                                       @click="handleGroup(scope.row)">开团

                            </el-button>
                            <el-button type="success" size="mini" v-show="scope.row.status == 1"
                                       @click="sendToSiYu(scope.row)">同步私域

                            </el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveList,
        getEnableallCityList,
        getKeywordsOption,
        saveActive,
        getValidDictionaryList,
        saveGrouponConfigApi,
        onlineCheckApi,
        getGrouponConfigApi,
        saveActivePageApi,
        getActivePageApi,
        getActiveParameter,
        saveActivePropertyApi,
        getActiveCheckInConfig,
        saveActiveCheckInConfig,
        saveMediatApi,
        copyActive
    } from '../../api/api';
    import Preview from "@/components/Preview";
    export default {
        components: {Preview},
        data() {
            var validateDate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value <= this.active.beginTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            var validateDate2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请选择日期'));
                } else if (value >= this.active.endTime) {
                    callback(new Error('结束日期不能小于开始日期!'));
                } else {
                    callback();
                }
            };
            return {
                linkType: 0,
                activeType: null,
                params: {},
                formInline: {
                    activeNo: this.$route.query.activeNo || '',
                    bindCode: this.$route.query.bindCode || '',
                    activeName: '',
                    platformId: 1,
                    activeType: '',
                    status: '',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                bindCode: '',
                showDialog: false,
                showGrouponDialog: false,
                showPageDialog: false,
                showInviteNum: false,
                showJoinNum: false,
                showPreviewDialog: false,
                loading: true,
                countdownList: [{id: 0, name: '否'}, {id: 1, name: '是'}],
                mediaEntity: {
                    type: 5,
                    itemId: '',
                    mediaType: 3
                },
                active: {
                    activeNo: '',
                    activeName: '',
                    tjType: 1,
                    deptId: 9,
                    status: 0,
                    beginTime: '',
                    endTime: '',
                    createTime: '',
                    payamount: 0,
                    bindCode: '',
                    activeType: 0,
                    cityId: 0,
                    keywordId: 0,
                    payKeywordId: 0,
                    vipRightType: '',
                    platformId: 1,
                    platformGroupId: 1000,
                    inviteNum: 0,
                    joinNum: 0,
                    categoryId: '',
                    isPeriod: 0,
                    countdown: 0,
                    remark: ''
                },
                platformList: [],//平台列表


                activeList: [],// 活动列表
                checkCachList: [],
                cachList: [],

                allowUserTypeList: [{id: 1, name: '新用户'}, {id: 2, name: '所有用户'}],
                platformDisabled: false,
                platformData: [],
                activeTypeList: [],

                groupListIsShow: [{id: 1, name: '显示'}, {id: 0, name: '不显示'}],
                mainGroup: [{id: 1, name: '是'}, {id: 0, name: '否'}],
                joinUserList: [{id: 1, name: '仅新用户'}, {id: 0, name: '所有用户'}],
                activeStatusList: [{id: 1, name: '已上线'}, {id: 0, name: '已下线'}],


            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getAllActivelist();
            this.getActiveTypeList();
        },
        methods: {
            getAllActivelist(){
                this.loading = true;
                getActiveList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.activeList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            checkActive(row){
                onlineCheckApi({"activeNo": row.activeNo, "status": row.status}).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getAllActivelist();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            sendToSiYu(row){
                this.mediaEntity.itemId = row.bindCode
                saveMediatApi(this.mediaEntity).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        //this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handlePreActive(row){
                this.activeType = row.activeType;
                this.params = {bindCode: row.bindCode, activeNo: row.activeNo};
                this.showPreviewDialog = true;
            },
            handlecopyActive(row){
                this.$confirm('复制此活动, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    copyActive({"activeNo": row.activeNo}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getAllActivelist();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            handleGroup(row){
                this.$router.push({path: '/grouponList', query: {bindCode: row.bindCode}})
            },
            getActiveTypeList(){
                getValidDictionaryList({
                    "platformGroupId": 1000, "dictionaryTypeId": 203, "currentPage": 1,
                    "pageSize": 50,
                }).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.activeTypeList = [];
                        for (let v of res.data.value.list) {
                            let type = {};
                            type.id = parseInt(v.dictionaryKey);
                            type.name = v.dictionaryName;
                            this.activeTypeList.push(type);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getActiveTypeName(activeType){
                for (var i = 0; i < this.activeTypeList.length; i++) {
                    if (this.activeTypeList[i].id == activeType) {
                        return this.activeTypeList[i].name;
                    }
                }
                return '';
            },
            getTongJiTypeName(tjType){
                for (var i = 0; i < this.tjTypeList.length; i++) {
                    if (this.tjTypeList[i].id == tjType) {
                        return this.tjTypeList[i].name;
                    }
                }
                return '';
            },
            getCityName(cityId){
                for (var i = 0; i < this.cityList.length; i++) {
                    if (this.cityList[i].cityId == cityId) {
                        return this.cityList[i].cityName;
                    }
                }
                return '全国';
            },
            getDepartmentName(deptId){
                for (var i = 0; i < this.depList.length; i++) {
                    if (this.depList[i].id == deptId) {
                        return this.depList[i].name;
                    }
                }
                return '';
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getAllActivelist();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getAllActivelist();
            },
            // getGrouponShow(activeType){
            //      return activeType==23;
            // },
            getFitType(activeType){
                return activeType == 22 || activeType == 19 || activeType == 1 || activeType == 28;
            },
            getPageShow(activeType){
                return true;
            },
            // handlePic(row){
            //     let routerL = '/'+this.$route.path.split('/')[1];
            //     this.$router.push({path:routerL+'/picture/'+row.activeNo,query:{picType:'15',picName:row.activeName,picState:'product'}})
            // },
            handleCoupon(row){
                //设置优惠券
                this.$router.push({
                    path: '/coupon',
                    query: {bindCode: row.bindCode, sourceName: row.activeName, type: '扫码后'}
                })
            },
            handlePromotion(row){
                if (row.promotionId != '') {
                    //跳转促销
                    this.$router.push({
                        path: '/promotionList',
                        query: {promotionId: row.promotionId}
                    })
                }
            },
            handleQrcode(row){
                this.$router.push({
                    path: '/activeQrMangement',
                    query: {activeNo: row.activeNo, activeName: row.activeName, activeType: row.activeType}
                });
            },
            handleRule(row){
                //活动规则
                this.$router.push({path: '/activeRule', query: {activeNo: row.activeNo, activeName: row.activeName}})
            },
            handlePicProperty(row){
                //活动图片属性
                this.$router.push({path: '/activeProperty', query: {activeNo: row.activeNo, bindCode: row.bindCode}})
            },
            handleGroupon(row){
                //配置团购
                this.grouponConfig.activeNo = row.activeNo;
                this.showGrouponDialog = true;
                this.getGrouponConfig();
            },
            handlePage(row){
                this.pageConfig = {
                    activePageId: '',
                    activeNo: row.activeNo,
                    activeSummary: '',
                    activeUrl: '',
                    color1: '',
                    color2: '',
                    isvip: 0,
                    vipRightType: '0',
                    activeContent: ''
                }
                this.showPageDialog = true;
                //this.getActivePage();
            },

            changeCategoryId(newValue){
                this.activeProperty.propertyValue = newValue;
            },
            reset(formName){
                this.$refs[formName].resetFields();
            },
            getActiveParameter(){
                getActiveParameter({'bindCode': active.bindCode, '': active.platformId}).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.cityList = res.data.value.cityList;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            addActive(){
                //添加活动
                this.$router.push({
                    path: '/active/activetabs',
                    name: 'activetabs',
                    query: {
                        activeNo: '',
                        bindCode: '',
                        activeName: '',
                        type: '扫码后',
                        activeType: -1,
                        curTab: "tab0",
                        picType: 15,
                        picFrom: "noReturn"
                    }
                })
            },
            editeActive(row){
                this.$router.push({
                    path: '/active/activetabs',
                    name: 'activetabs',
                    query: {
                        activeNo: row.activeNo,
                        bindCode: row.bindCode,
                        activeName: row.activeName,
                        type: '扫码后',
                        activeType: row.activeType,
                        curTab: "tab0",
                        picType: 15,
                        picFrom: "noReturn"
                    }
                })

            },
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-order {
        .customer-nick {
            margin: 0;
        }
        .el-table th {
            background: #f1f1f1;
            color: #222222;
        }
        .el-table__expanded-cell {
            background: #f5f5f5;
            text-align: left;
            padding: 7px 50px;
        }
        .el-table__expanded-cell:hover {
            background: #f5f5f5 !important;
        }
        .expand-title {
            width: 70px;
            color: #444548;
            line-height: 30px;
            text-align: right;
            margin-right: 10px;
            font-weight: 600;
        }
        .expand-flex, .expand-flex-con {
            justify-content: flex-start;
            align-items: center;
            align-content: center;
        }
        .expand-flex-con {
            display: flex;
            flex-wrap: wrap;
            .expand-content {
                margin: 5px 10px 5px 0;
            }
        }
        .el-table__expand-icon > .el-icon {
            font-size: 16px;
            font-weight: bolder;
        }
        .el-divider--horizontal {
            margin: 10px 0;
        }
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/active/activeManagement.vue